import React from 'react';
import ChannelsTable from '../../components/ChannelsTable';
import { StudioPage } from '../../components/StudioPage';

/**
 * 渠道管理页面容器
 * 修改时间：2026-06-12
 */
const Channel = () => {
  return (
    <StudioPage className='studio-management-page'>
      <ChannelsTable />
    </StudioPage>
  );
};

export default Channel;
